import { createLogger } from 'shared/services/logger';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope');

const logger = createLogger('UScope:lib:LegacyAjaxWrapper');

export default function LegacyAjaxWrapper (uScope, viewport, imageId) {
  var self = this;

  // ................................................................. doIMGSRVREQ
  //    doIMGSRVREQ: This function sends a request to image server
  //    parameters:
  //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
  //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
  //        requestName            required, dataserver request name
  //        opt_cbParms            optional, parms to send to call back function
  //        opt_datatype:        optional, defulat is 'xml',  {'xml, 'html}
  //                            IE issue:  it seems that the return xml from getannotatons of "<Annotations/>"
  //                            cannot interpreted properly so just get the text w/o interpretation.
  //                            DataServer calls always provide the results wrapped in XML and can be interpreted properly.
  //                            Note that when dataType is 'html' then HTML is returned as plain text
  //
  //        opt_reqImageId:        optional, imageId to request xinfo of; default is viewport; markup images provide this;

  self.queryImageServer = (query) => {
    return $.post(self.buildFullUrl(), query)
      .then((...args) => {
        if (!isImageStillValid()) {
          return $.Deferred().reject($t('invalid-image-error-message'));
        }
        return $.Deferred().resolve(...args);
      });
  };

  this.doIMGSRVREQ = function (cbSuccessFn, cbFailureFn, requestName, opt_cbParms, opt_datatype = 'xml', opt_reqImageId = imageId) {
    var parms = {
      type: 'POST',
      timeout: 6000,
      cache: false,
      async: true,
      dataType: opt_datatype,
      data: requestName,
      success: function (data, textStatus, jqXHR) {
        if (isImageStillValid() == false) return;

        if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
        else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        if (isImageStillValid() == false) return;

        if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
        else defaultFailureFn(' Error: doIMGSRVREQ ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
      }
    };
    // add authentication to the request parameters and issue the ajax request
    if (ajaxAddAuth('doIMGSRVREQ', parms, (opt_reqImageId))) { $.ajax(parms); }
  };

  // ................................................................. doDATASVRREQ
  // doDATASVRREQ - This function sends a DoDBCall to ImageServer.
  //                    e.g. ImageServer request: GET <path>?DODBCALL+<method>+<input xml to method>
  // passed parameters:
  //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
  //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
  //        requestName            required, dataserver request name
  //        strXML                required, xml string specifying specifics of the request
  //        opt_cbParms            optional, parms to send to call back function

  this.doDATASVRREQ = function (cbSuccessFn, cbFailureFn, requestName, strXML, opt_cbParms) {
    var parms = {
      type: 'POST',
      timeout: 6000,
      cache: false,
      async: true,
      dataType: 'html', // 'html' datatype prevents IE complaints about XML
      data: 'DODBCALL' + '+' + requestName + '+' + strXML,

      success: function (data, textStatus, jqXHR) {
        if (isImageStillValid() == false) return;

        if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
        else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        if (isImageStillValid() == false) return;

        //        if (textStatus == "parsererror") {                // IE is touchy about the garbage at the end of the xml returned from imageserver
        //            cbSuccessFn(undefined, textStatus, jqXHR, cbParms);

        if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
        else defaultFailureFn(' Error: DODBCALL ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
      }
    };
    // add authentication to the request parameters and issue the ajax request
    if (ajaxAddAuth('doDATASVRREQ: ' + requestName, parms, imageId)) { $.ajax(parms); }
  };

  // ................................................................. doANALSVRREQ
  // doANALSVRREQ - This function sends a DoIACall to ImageServer.
  //                    e.g. ImageServer request: GET <path>?DOIACALL+<method>+<input xml to method>
  //  The syntax of DOIACALL is:
  //    http://<hostname>/@@<token>/@<imageid>?DOIACALL+<methodname>+<inputparameters>.
  //  Note the input parameters are not formatted with SOAP headers.
  //
  // passed parameters:
  //        cbSuccessFn            optional,callback function upon success; a default report fn is called if not specified
  //        cbFailureFn            optional,callback function upon failure; a default report fn is called if not specified
  //        requestName            required, dataserver request name
  //        strXML                required, xml string specifying specifics of the request
  //        opt_cbParms            optional parms to send to call back function

  this.doANALSVRREQ = function (cbSuccessFn, cbFailureFn, requestName, strXML, opt_cbParms) {
    var urlXML = encodeURIComponent(strXML); // analysis server inputparameters must be uri encoded
    var parms = {
      type: 'POST',
      timeout: 6000,
      cache: false,
      async: true,
      dataType: 'html', // 'html' datatype prevents IE complaints about XML
      data: 'DOIACALL' + '+' + requestName + '+' + urlXML,

      success: function (data, textStatus, jqXHR) {
        if (isImageStillValid() == false) return;

        if (cbSuccessFn) cbSuccessFn(data, textStatus, jqXHR, opt_cbParms); //
        else defaultSuccessFn(data, textStatus, jqXHR, opt_cbParms, requestName);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        if (isImageStillValid() == false) return;

        if (cbFailureFn) cbFailureFn(jqXHR, textStatus, errorThrown, opt_cbParms); //
        else defaultFailureFn(' Error: DOIACALL ' + requestName + self.getErrorStr(jqXHR, textStatus, errorThrown, imageId));
      }
    };
    // add authentication to the request parameters and issue the ajax request
    if (ajaxAddAuth('doANALSVRREQ: ' + requestName, parms, imageId)) { $.ajax(parms); }
  };

  // buildFullUrl - This function uses the currently selected image to create a full url for the passed imageId
  self.buildFullUrl = (reqImageId = imageId) => { // note tha imageId must have leading @ sign
    var url = '';
    var fullURL = uScope.getFullURL(); // assumes a selected image
    if (fullURL) {
      var idx = fullURL.lastIndexOf('@');
      if (idx > 0) {
        url = fullURL.substr(0, idx) + reqImageId;
      }
    }
    return url;
  };

  // ................................................................. ajaxAddAuth
  //    ajaxAddAuth - This function adds authentication to the passed associative array
  var ajaxAddAuth = function (callerName, parms, reqImageId) {
    parms.url = self.buildFullUrl(reqImageId); // build url with the requested image's Id
    return true;
  };

    // ................................................................. getErrorStr
  this.getErrorStr = function (jqXHR, textStatus, errorThrown, imageId) {
    var str = ' (' + imageId + ')';
    if (jqXHR && jqXHR.responseText) {
      var idx = jqXHR.responseText.indexOf(';');
      var rtext = (idx != -1) ? jqXHR.responseText.slice(0, idx) : jqXHR.responseText;
      str += ' status: ' + jqXHR.status + ', responseText: ' + rtext;
    } else {
      str += ' errorThrown: ' + errorThrown;
    }
    return str;
  };
  // ................................................................. isImageStillValid
  var isImageStillValid = function () {
    if (uScope.isThisImageIdValid(imageId) == false) { // protect against rapid slide close/open sequence s.t. vpObj no longer is loaded
      logger.error('Error: ajax request: image is no longer valid: ' + imageId);
      return false;
    }
    return true;
  };
    // ................................................................. defaultSuccessFn
  var defaultSuccessFn = function (data, textStatus, jqXHR, cbParms, requestName) {
    logger.log('defaultSuccessFn: ' + requestName + '\n' + jqXHR.responseText);
  };
    // ................................................................. defaultFailureFn
  var defaultFailureFn = function (str) {
    logger.error(str);
  };
}

// TODO: (cc) This code looks very MS specific but I'm not seeing any feature/browser branching. Dead code???
$.ajaxTransport(function (options, originalOptions, jqXHR) {
  var xdr;
  return {
    send: function (unused, completeCallback) {
      logger.log('ajaxtransport:send');
      xdr = new XDomainRequest();
      xdr.onload = function () {
        logger.log('ajaxtransport:onload');
        var responses = {
          text: xdr.responseText
        };
        if (xdr.contentType.match(/\/xml/)) {
          // there is no responseXML in XDomainRequest, so we have to create it manually
          var dom = new window.ActiveXObject('Microsoft.XMLDOM');
          dom.async = false;
          dom.loadXML(xdr.responseText);
          responses.xml = dom;

          if ($(dom).children('error').length != 0) {
            var $error = $(dom).find('error');
            completeCallback(parseInt($error.attr('response_code'), 10), $error.attr('message_key'), responses);
          } else {
            completeCallback(200, 'success', responses);
          }
        } else {
          // set status code to 200
          // XDomainRequest rejects all other successful status codes
          completeCallback(200, 'success', responses);
        }
      }; // send
      xdr.onerror = xdr.ontimeout = function () {
        logger.log('ajaxtransport:onerror');
        var responses = {
          text: xdr.responseText
        };
        completeCallback(400, 'failed', responses);
      };
      xdr.onprogress = function () {
        logger.log('ajaxtransport:onprogress');
      };
      xdr.ontimeout = function () {
        logger.log('ajaxtransport:ontimeout');
      };
      xdr.open(options.type, options.url);
      if (options.type == 'POST') {
        xdr.send(options.data);
      }
    },
    abort: function () {
      logger.log('ajaxtransport:abort');
      if (xdr) {
        xdr.abort();
      }
    }
  };
});



// WEBPACK FOOTER //
// ./src/uScope/js/lib/data/legacy-ajax-wrapper.js